module.exports = __webpack_public_path__ + "img/JT_icons01_64px_Like.950775cd.svg";